import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ChampOuterCon } from './styles'
import { LeagueContext } from '../../Context'
import { GamesCon, ChampionshipCon } from './Matchups'
import { EventGQL } from '../../Api'
import { PLL_IMAGES } from '../../Config/config'
import { isPostseason } from '../../Utils'
import { Box } from '../Layout'

export const BracketContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { events } = useContext(LeagueContext)!
  const [eventList, setEventList] = useState<EventGQL[]>([])

  useEffect(() => {
    if (!isPostseason(events)) return
    const playoffEvents = events.filter((ev) => ev.seasonSegment === 'post')
    if (playoffEvents.length >= 1) {
      setEventList(playoffEvents)
    }
  }, [events])

  const champion = useMemo(() => {
    const championshipGm = eventList.find((ev) => ev.slugname.includes('champion'))
    //Game has ended, get champion
    if (championshipGm && championshipGm.eventStatus > 1) {
      return championshipGm.homeScore > championshipGm.visitorScore ? championshipGm.homeTeam : championshipGm.awayTeam
    }
    return null
  }, [eventList])

  return (
    <>
      {eventList.length > 0 && (
          <Box boxColor="dark" padding={0} vertMargins={2} bgImg={PLL_IMAGES.bracketBackground} noMargin>
            <ChampOuterCon>
              {eventList.length > 0 && <GamesCon events={eventList} />}
              {eventList.length > 0 && <ChampionshipCon events={eventList} champion={champion} />}
            </ChampOuterCon>
          </Box>
      )}
    </>
  )
}
